import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AppInformationService, AuthService, GenesisUnitOfWork, QuickbooksService } from '../../core/core.module';
import { alert } from 'devextreme/ui/dialog';
import { BsModalService } from 'ngx-bootstrap/modal';
import { QuickbooksExportDialogComponent } from '../quickbooks-export-dialog/quickbooks-export-dialog.component';
import { Dealer, PackingSlip, PurchaseOrder, Vendor } from 'app/core/model/entity-model';
import _ from 'lodash';

@Component({
    selector: 'app-quickbooks',
    templateUrl: './quickbooks.component.html',
    styleUrls: ['./quickbooks.component.scss'],
    standalone: false
})
export class QuickbooksComponent implements OnInit {
    quickbooks = { status: 'unknown' } as any;
    readOnly = true as boolean;
    invoicesToExport: any;
    dealersToExport: any;

    constructor(
        private auth: AuthService,
        private uow: GenesisUnitOfWork,
        private quickbooksService: QuickbooksService,
        private route: ActivatedRoute,
        private appInfo: AppInformationService,
        private router: Router,
        private modalService: BsModalService
    ) { }

    async ngOnInit() {
        this.readOnly = !this.auth.hasRole('Admin');
        this.route.queryParams.subscribe((params) => {
            this.checkStatus(params);
        });
    }

    async connect() {
        this.appInfo.pleaseWaitShow();
        const authorizeUrl = await this.quickbooksService.authorize();
        if (authorizeUrl && authorizeUrl.trim().length > 0) document.location.href = authorizeUrl;
        else this.checkStatus(null);
        this.appInfo.pleaseWaitHide();
    }

    async disconnect() {
        this.appInfo.pleaseWaitShow();
        await this.quickbooksService.disconnect();
        this.checkStatus(null);
        this.appInfo.pleaseWaitHide();
    }

    async checkStatus(params) {
        this.appInfo.pleaseWaitShow();
        let isAuthorized;
        if (params && params.code && params.realmId && params.state) {
            isAuthorized = await this.quickbooksService.authorizeCallback(params.code, params.realmId, params.state);
            this.router.navigate(['/admin/quickbooks'], { replaceUrl: true });
        } else {
            isAuthorized = await this.quickbooksService.isAuthorized();
        }
        this.quickbooks.status = isAuthorized ? 'Connected' : 'Disconnected';
        this.appInfo.pleaseWaitHide();
    }

    async startDealerExport() {
        const dealersToExport = (await this.uow.getDealersForExport()) as Dealer[];
        console.log(dealersToExport);
        const modalRef = this.modalService.show(QuickbooksExportDialogComponent, {
            class: 'modal-lg',
            ignoreBackdropClick: true,
            keyboard: false,
            initialState: {
                items: dealersToExport,
                mode: 'dealers'
            },
        });

        modalRef.content.result.subscribe(async (result) => {
            if (result.success) {
                await this.exportDealers(dealersToExport);
            }
            modalRef.hide();
        });
    }

    async exportDealers(dealers: Dealer[]) {
        this.appInfo.pleaseWaitShow();
        const response = (await this.quickbooksService.dealerExport()) as any;
        this.appInfo.pleaseWaitHide();
        if (response.success) {
            alert(`Success Count: ${response.successCount}; Fail Count: ${response.failCount}`, 'Results');
        } else {
            alert(`An error occurred. Check status to make sure a Connection still exists.`, 'Error');
        }


        const items = response.result;
        items.forEach(x => {
            const entity = (_.find(dealers, { 'id': Number(x.Id) }) as any);
            x.invoiceNumber = entity.id;
            x.dealer = entity.companyName;
            if (x.Status === 0) x.Message = 'Success';

        });

        console.log(items);
        const modalRef = this.modalService.show(QuickbooksExportDialogComponent, {
            class: 'modal-lg',
            ignoreBackdropClick: true,
            keyboard: false,
            initialState: {
                items: items,
                mode: 'invoiceResults',
                showingResults: true
            },
        });

        modalRef.content.result.subscribe(async (result) => {
            if (result.success) {
            }
            modalRef.hide();
        });
    }

    async syncDealerIds() {
        this.appInfo.pleaseWaitShow();
        const response = (await this.quickbooksService.dealerSyncIds()) as any;
        this.appInfo.pleaseWaitHide();
        if (response.success) {
            alert(`Success Count: ${response.successCount}; Fail Count: ${response.failCount}`, 'Results');
        } else {
            alert(`An error occurred. Check status to make sure a Connection still exists.`, 'Error');
        }
    }

    async startVendorExport() {
        const vendors = (await this.uow.getVendorsForExport()) as Vendor[];
        console.log(vendors);
        const modalRef = this.modalService.show(QuickbooksExportDialogComponent, {
            class: 'modal-lg',
            ignoreBackdropClick: true,
            keyboard: false,
            initialState: {
                items: vendors,
                mode: 'vendors'
            },
        });

        modalRef.content.result.subscribe(async (result) => {
            if (result.success) {
                await this.exportVendors(vendors);
            }
            modalRef.hide();
        });
    }

    async exportVendors(vendors: Vendor[]) {
        this.appInfo.pleaseWaitShow();
        const response = (await this.quickbooksService.vendorExport()) as any;
        this.appInfo.pleaseWaitHide();
        if (response.success) {
            alert(`Success Count: ${response.successCount}; Fail Count: ${response.failCount}`, 'Results');
        } else {
            alert(`An error occurred. Check status to make sure a Connection still exists.`, 'Error');
        }

        const items = response.result;
        items.forEach(x => {
            const entity = (_.find(vendors, { 'id': Number(x.Id) }) as any);
            x.invoiceNumber = entity.id;
            x.dealer = entity.companyName;
            if (x.Status === 0) x.Message = 'Success';

        });

        console.log(items);
        const modalRef = this.modalService.show(QuickbooksExportDialogComponent, {
            class: 'modal-lg',
            ignoreBackdropClick: true,
            keyboard: false,
            initialState: {
                items: items,
                mode: 'invoiceResults',
                showingResults: true
            },
        });

        modalRef.content.result.subscribe(async (result) => {
            if (result.success) {
            }
            modalRef.hide();
        });
    }

    async syncVendorIds() {
        this.appInfo.pleaseWaitShow();
        const response = (await this.quickbooksService.vendorSyncIds()) as any;
        this.appInfo.pleaseWaitHide();
        if (response.success) {
            alert(`Success Count: ${response.successCount}; Fail Count: ${response.failCount}`, 'Results');
        } else {
            alert(`An error occurred. Check status to make sure a Connection still exists.`, 'Error');
        }
    }

    async startPurchaseExport() {
        const dealersToExport = (await this.uow.getPurchaseOrdersForExport()) as PurchaseOrder[];
        console.log(dealersToExport);
        const modalRef = this.modalService.show(QuickbooksExportDialogComponent, {
            class: 'modal-lg',
            ignoreBackdropClick: true,
            keyboard: false,
            initialState: {
                items: dealersToExport,
                mode: 'purchaseOrders'
            },
        });

        modalRef.content.result.subscribe(async (result) => {
            if (result.success) {
                await this.exportPurchaseOrders(dealersToExport);
            }
            modalRef.hide();
        });
    }

    async exportPurchaseOrders(purchaseOrders: PurchaseOrder[]) {
        this.appInfo.pleaseWaitShow();
        const response = (await this.quickbooksService.purchaseOrderExport()) as any;
        this.appInfo.pleaseWaitHide();
        if (response.success) {
            alert(`Success Count: ${response.successCount}; Fail Count: ${response.failCount}`, 'Results');
        } else {
            alert(`An error occurred. Check status to make sure a Connection still exists.`, 'Error');
        }

        const items = response.result;
        items.forEach(x => {
            const entity = (_.find(purchaseOrders, { 'id': Number(x.Id) }) as any);
            x.invoiceNumber = entity.id;
            x.dealer = entity.vendor.companyName;
            if (x.Status === 0) x.Message = 'Success';

        });

        console.log(items);
        const modalRef = this.modalService.show(QuickbooksExportDialogComponent, {
            class: 'modal-lg',
            ignoreBackdropClick: true,
            keyboard: false,
            initialState: {
                items: items,
                mode: 'invoiceResults',
                showingResults: true
            },
        });

        modalRef.content.result.subscribe(async (result) => {
            if (result.success) {
            }
            modalRef.hide();
        });



    }

    async startExportInvoices() {
        this.invoicesToExport = (await this.uow.getInvoicesForExport()) as PackingSlip[];
        console.log(this.invoicesToExport);
        let doExport = false;
        const modalRef = this.modalService.show(QuickbooksExportDialogComponent, {
            class: 'modal-lg',
            ignoreBackdropClick: true,
            keyboard: false,
            initialState: {
                items: this.invoicesToExport,
                mode: 'invoices'
            },
        });

        modalRef.content.result.subscribe(async (result) => {
            if (result.success) {
                doExport = true;
                await this.exportInvoices();
            }
            modalRef.hide();
        });
    }

    async exportInvoices() {
        this.appInfo.pleaseWaitShow();
        const response = (await this.quickbooksService.invoiceExport()) as any;
        this.appInfo.pleaseWaitHide();
        if (response.success) {
            alert(`Success Count: ${response.successCount}; Fail Count: ${response.failCount}`, 'Results');
        } else {
            await alert(`An error occurred. Check status to make sure a Connection still exists.`, 'Error');
        }

        const items = response.result;
        items.forEach(x => {
            const invoice = (_.find(this.invoicesToExport, { 'id': Number(x.Id) }) as any);
            x.invoiceNumber = invoice.invoiceNumber;
            x.dealer = invoice.dealer.companyName;
            if (x.Status === 0) x.Message = 'Success';

        });

        console.log(items);
        const modalRef = this.modalService.show(QuickbooksExportDialogComponent, {
            class: 'modal-lg',
            ignoreBackdropClick: true,
            keyboard: false,
            initialState: {
                items: items,
                mode: 'invoiceResults',
                showingResults: true
            },
        });

        modalRef.content.result.subscribe(async (result) => {
            if (result.success) {
            }
            modalRef.hide();
        });

    }
}
